"use client";

import React from "react";
import { Zap, ShieldCheck, Blocks, Headset } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  id: 1,
  title: "Mapa aktivnosti",
  description: "Pristupite lokacijama cijele radne snage i statusu aktivnosti na lokacijama u stvarnom vremenu putem interaktivne mape.",
  icon: "Zap"
}, {
  id: 2,
  title: "Klijentski WEB portal",
  description: "Omogućite klijentima pristup izvještajima o aktivnostima putem portala kao dokaz vrhunske usluge koju pružate.",
  icon: "ShieldCheck"
}, {
  id: 3,
  title: "Mobilne jedinice",
  description: "Pratite aktivnost i učinak svojih mobilnih timova u stvarnom vremenu dok koriste vozila za obilazak lokacija klijenata.",
  icon: "Blocks"
}, {
  id: 4,
  title: "Email obavijesti",
  description: "Šaljite automatske email obavijesti menadžerima i klijentima o svim važnim događajima i završenim zadacima.",
  icon: "Headset"
}];
const iconMap: Record<string, React.ElementType> = {
  Zap,
  ShieldCheck,
  Blocks,
  Headset
};
export default function FeaturesBenefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="237814" id="cjelovito-rješenje" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary font-default mb-4">
            Cjelovito <span className="text-primary">digitalno rješenje</span> za vašu tvrtku
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-default text-lg">
            Otkrijte moćne alate i prednosti dizajnirane da vam pomognu postići ciljeve brže i učinkovitije uz potpunu transparentnost.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {features.map((feature, i) => {
          const Icon = iconMap[feature.icon];
          return <Card key={feature.id} data-index={i} className="bg-card border-border shadow-sm rounded-lg h-full flex flex-col hover:shadow-md transition-shadow duration-300">
                <CardHeader className="pb-4">
                  <div className="flex justify-center w-full mb-6">
                    <div className="p-3 bg-accent rounded-lg">
                      {Icon && <Icon className="w-10 h-10 text-primary" strokeWidth={1.5} />}
                    </div>
                  </div>
                  <CardTitle className="text-foreground font-bold text-xl text-left font-default">
                    {feature.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0 flex-grow">
                  <CardDescription className="text-muted-foreground text-left text-base font-default leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
        
        <div className="mt-16 flex justify-center">
          <Link to="/FeaturesPage" id="learn_more_features_button" className="bg-primary text-primary-foreground px-8 py-4 rounded-lg font-semibold text-lg shadow-3xl hover:opacity-90 transition-opacity font-default">
            Saznajte više o značajkama
          </Link>
        </div>
      </div>
    </section>;
}